const contractorPostingsFiltersTemplate = {
  jobTitle: "",
  countries: [],
  states: [],
  cities: [],
  skills: [],
  industries: [],
  companies: [],
  minDuration: "",
  maxDuration: "",
};

export default contractorPostingsFiltersTemplate;